<form class="layout-form" [formGroup]="questionAndAnswersForm" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header">
      <p>Actividad de tu Comercio</p>
      <span> Complete el formulario </span>
    </div>
    <div class="scroll-display">
      <div *ngIf="questions">
        <div [@fadeInOut] class="form-select-content" *ngFor="let question of questions; let i = index">
          <app-select
            [labelText]="question.description"
            [placeholder]="'Seleccionar'"
            [required]="true"
            [labelWarningGenericText]="true"
            [formControlName]="'questionId' + question.id"
            [disabled]="!minimumPurchase"
            [submitted]="submitted"
            [options]="answers[i].answers"
          ></app-select>
        </div>
      </div>
    </div>
    <div *ngIf="minimumPurchase" class="form-checkbox">
      <mat-checkbox data-testid="check-compra-semanal" formControlName="weeklyPurchase"></mat-checkbox>
      <p class="form-checkbox--text">
        <span>
          La propiedad del comercio no se encuentra en una casa y acepto realizar compras semanales por un importe
          mínimo de {{ minimumPurchase }}</span
        >
      </p>
    </div>
    <div class="warning-label" *ngIf="!minimumPurchase">
      <span>
        Lamentamos informarte que la dirección informada no corresponde a una zona de cobertura de Coca-Cola Paresa. En
        este lugar opera un distribuidor autorizado de Coca-Cola Paresa. Para conocer con quién interactuar, te
        sugerimos comunicarte con nosotros
        <a class="warning-label-a" href="https://wa.me/54116842115" target="_blank" rel="noopener">ingresando aquí</a>.
      </span>
    </div>
    <div
      class="warning-label"
      *ngIf="submitted && !this.questionAndAnswersForm.controls['weeklyPurchase'].valid && minimumPurchase"
    >
      Debe aceptar para continuar.
    </div>
  </div>
  <div class="form-navigation">
    <app-navigation [currentStep]="3" [countSteppers]="7"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Anterior</button>
    <button mat-raised-button class="next-button next-button__60" [disabled]="!minimumPurchase" type="submit">
      Siguiente
    </button>
  </div>
</form>
